<template>
  <div>
 <nvs/>
  </div>
</template>

<script>
import nvs from '@/components/Nvs.vue'
export default {
    components: {nvs}
};
</script>

<style>
</style>